import React from 'react';
import {View} from 'react-native';

import ProfileHeader from '/component/base/ProfileHeader';
import Gutter from '/component/layout/Gutter';
import {withTranslation} from '/provider/TranslationProvider';

import {styles} from './Header.style';
interface HeaderProps {
  fullName: string;
  avatarUrl: string;
  accountEmail: string;
  clientId: number | null;
}

export const Header = ({
  fullName = '',
  avatarUrl = '',
  accountEmail = '',
  clientId = null,
}: HeaderProps) => (
  <View style={styles.base}>
    <Gutter>
      <ProfileHeader
        title={() => null}
        name={`${fullName}`}
        avatarUrl={avatarUrl}
        email={accountEmail}
        isCoach={false}
        optaviaId={clientId}
      />
    </Gutter>
  </View>
);

export default withTranslation('screen.clientProfile.header')(Header);
